import { css } from '@emotion/css';

const mainContainer = css({
  marginBottom: '0.25rem',
});

const inputContainer = css({
  marginBottom: '0.5rem',
});

const labelText = css({
  display: 'block',
  width: '100%',
});

const rightPlaceholder = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0.25rem',
  height: '100%',
  minHeight: '40px',
});

const PromoterRateInputStyles = {
  mainContainer,
  inputContainer,
  labelText,
  rightPlaceholder,
};

export default PromoterRateInputStyles;
